<template>
    <div class="pt-3">
        <nav class="navbar navbar-expand-lg navbar-light">
            <div class="ml-auto">
                <button class="btn btn-info my-2 my-sm-0"
                        @click="onCreate"
                        type="button">
                    เพิ่มโควต้าสินค้า
                </button>
            </div>
        </nav>
        <div class="col-12 table-responsive">
            <table class="table table-bordered" style="text-align: center">
                <thead>
                <tr>
                    <th scope="col">สถานะ</th>
                    <th scope="col">รหัสโควต้า</th>
                    <th scope="col">ประเภทสินค้า</th>
                    <th scope="col">รหัสสินค้า</th>
                    <th scope="col">ชื่อสินค้า</th>
                    <th scope="col">วันที่สร้าง</th>
                    <th scope="col">จำนวนนำเข้า</th>
                    <th scope="col">เศษคงเหลือ</th>
                    <th scope="col">ช่วงวันที่กำหนด/วัน</th>
                    <th scope="col">ผู้อัปเดต</th>
                    <th scope="col">จัดการ</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(x,i) in list">
                    <td>{{x.active}}</td>
                    <td>{{x.no}}</td>
                    <td>{{x.product && x.product.product_type ? x.product.product_type.name : '-'}}</td>
                    <td>{{x.product ? x.product.sku : '-'}}</td>
                    <td>{{x.product ? x.product.name : '-'}}</td>
                    <td>{{x.created_at | moment("DD/MM/YYYY")}}</td>
                    <td>{{x.real_stock}}</td>
                    <td>{{x.remain}}</td>
                    <td>{{x.date_range}}</td>
                    <td>{{x.update_by ? x.update_by.name : '-'}}</td>
                    <td>
                        <a @click="onEdit(x.id)" class="mr-2"><icon name="pencil-alt"></icon></a>
                        <a @click="onDelete(x.id)"><icon name="trash-alt"></icon></a>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
        <b-modal hide-footer hide-header ref="loading">
            <loading :msg="msg" :status="status" @submit="hideLoadingModal"></loading>
        </b-modal>
    </div>
</template>

<script>
import {mapState} from "vuex";
import VuePagination from "../Pagination";
import Multiselect from "vue-multiselect";

import {
    canViewSuperAdmin
} from "../../util/Permissions";

import Loading from "../Utility/Loading";

export default {
    name: "quota-list",
    components: {
        Loading,
        VuePagination,
        Multiselect
    },
    data() {
        return {
            msg: '',
            status: '',
            search_text: '',
            list: [],
            optionEmployee: []
        };
    },
    created() {
        // this.$store.dispatch('Users/getList').then(res => this.optionEmployee = res)
        this.getList();
    },
    computed: {
        canViewSuperAdmin,
        ...mapState({
            user: state => {
                return state.Auth.user;
            },
        })
    },
    methods: {
        customLabel(option) {
            return `${option.username} - ${option.name}`
        },
        onCreate(){
            this.$router.push('/quota-create');
        },
        showLoadingModal() {
            this.$refs.loading.show();
        },
        hideLoadingModal() {
            this.$refs.loading.hide();
        },
        getList() {
            this.$store.dispatch('Seller/getListQuota').then(res => {
                this.list = res
            });
        },
        onEdit(id){
            this.$router.push({
                name: 'quota-create',
                params: { id:id }
            });
        },
        onDelete(id){
            this.$store.dispatch('Seller/deleteQuota',id).then(() => {
                this.getList();
            });
        }
    },
}
</script>

<style lang="scss" scoped>
</style>
